export const REPORTING_CONFIG_CONSTANTS = {
  TASK_SUMMARY_REPORT: 'taskSummaryReport',
  TASK_EMPLOYEE_PRODUCTIVITY_REPORT: 'taskEmployeeProductivityReport',
  COMPLETED_WORK_REPORT: 'completed-work-report',
  TEMPLATE_SUBMISSIONS_REPORT: 'templateSubmissionsReport',
  SCHEDULED_WORK_REPORT: 'scheduledWorkReport',
};
